module.exports = __webpack_public_path__ + "img/gifts.8053636b.png";